module.exports = __webpack_public_path__ + "assets/img/bowler.c40ab4a6.jpg";